import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { trackPromise } from "react-promise-tracker";
import { retrieveUserGroups, retrieveOneUserGroup, setSelectedGroup } from "../slices/userGroupSlice";

import { debugLog, errorLog } from "../utils/debugUtils";

// Custom hook for userGroups module async actions (fetching list, fetching single userGroup, etc.)
export const useUserGroupsData = () => {
	const dispatch = useDispatch();

	const fetchUserGroups = useCallback(() => {
		debugLog(3, "[useUserGroupsData][ACTION] fetchUserGroups", {});
		debugLog(2, "[useUserGroupsData][FLOW] retrieveUserGroups started", {});
		trackPromise(
			dispatch(retrieveUserGroups())
				.unwrap()
				.then((response) => {
					debugLog(3, "[useUserGroupsData][STATE] fetchUserGroups success", {
						count: response?.length ?? 0,
					});
				})
				.catch((err) => {
					errorLog(2, "[useUserGroupsData][FLOW] retrieveUserGroups failed", { error: err });
					console.error("retrieveUserGroups failed", err);
				}),
		);
	}, [dispatch]);

	const fetchUserGroupById = useCallback(
		(id) => {
			debugLog(3, "[useUserGroupsData][ACTION] fetchUserGroupById", { id: id });
			const action = retrieveOneUserGroup(id);
			debugLog(2, "[useUserGroupsData][FLOW] retrieveOneUserGroup started", { id: id });

			trackPromise(
				dispatch(action)
					.unwrap()
					.then((response) => {
						debugLog(3, "[useUserGroupsData][STATE] fetchUserGroupById success", {
							id: response?.id,
							name: response?.name,
						});

						dispatch(setSelectedGroup(response));
					})
					.catch((err) => {
						errorLog(2, "[useUserGroupsData][FLOW] retrieveOneUserGroup failed", {
							id: id,
							error: err,
						});
						console.error("retrieveOneUserGroup failed", err);
					}),
			);
		},
		[dispatch],
	);

	return {
		fetchUserGroups,
		fetchUserGroupById,
	};
};
